import { createReducer, on } from "@ngrx/store";
import { TutorState, initialTutorState } from "./tutor.state";
import { AddTutor, AddTutorSuccess, AddTutorError, ResetTutorState, ResetTutorTable, ResetTutorTableSuccess, ResetTutorTableError, GetTutorTable, GetTutorTableSuccess, GetTutorTableError, GetTutorTableLength, GetTutorTableLengthSuccess, GetTutorTableLengthError, ResetTutorCrud, GetTutorUserProfileError, GetTutorUserProfile, GetTutorUserProfileSuccess, UpdateTutorGroupTable, GetGroupTutorCount, GetGroupTutorCountSuccess, GetGroupTutorCountError, TutorHasAccessToLearner, TutorHasAccessToLearnerSuccess, TutorHasAccessToLearnerError, GetCurrentPageNumber, GetCurrentPageNumberSuccess, GetCurrentPageNumberError, UpdateTutorAccountStatus, UpdateTutorAccountStatusSuccess, UpdateTutorAccountStatusError, ResetUpdateTutorAccountStatusProps, UpdateTutorTable } from "./tutor.actions";

export const TutorReducers = createReducer(
  initialTutorState,
  on(AddTutor, (state): TutorState => {
    return {
      ...state,
      crudResult: null,
      crudTutorLoader: true,
      crudTutorError: null,
    };
  }),
  on(AddTutorSuccess, (state, action): TutorState => {
    return {
      ...state,
      crudResult: action.result,
      crudTutorLoader: false,
      crudTutorError: null,
    };
  }),
  on(AddTutorError, (state, action): TutorState => {
    return {
      ...state,
      crudTutorLoader: false,
      crudTutorError: action.crudTutorError,
    };
  }),
  on(ResetTutorState, (): TutorState => {
    return initialTutorState;
  }),
  on(ResetTutorTable, (state): TutorState => {
    return {
      ...state,
      tutorTableLoader: true,
      isInitialLoadFlowReset: false,
    };
  }),
  on(ResetTutorTableSuccess, (state, action): TutorState => {
    return {
      ...state,
      tutorTableLoader: false,
      isInitialLoadFlowReset: action.isInitialLoad,
    };
  }),
  on(ResetTutorTableError, (state, action): TutorState => {
    return {
      ...state,
      tutorTableLoader: false,
      tableTutorError: action.error,
      isInitialLoadFlowReset: false,
    };
  }),
  on(GetTutorTable, (state): TutorState => {
    return {
      ...state,
      tutorTableLoader: true,
      tableTutorError: false,
    };
  }),
  on(GetTutorTableSuccess, (state, action): TutorState => {
    return {
      ...state,
      tutorTableLoader: false,
      tutorTableRecords: action.result,
      tableTutorError: false,
    };
  }),
  on(GetTutorTableError, (state, action): TutorState => {
    return {
      ...state,
      tutorTableLoader: false,
      tutorTableError: action.tutorTableError,
    };
  }),
  on(GetTutorTableLength, (state): TutorState => {
    return {
      ...state,
    };
  }),
  on(GetTutorTableLengthSuccess, (state, action): TutorState => {
    return {
      ...state,
      tutorRecordsLength: action.length,
    };
  }),
  on(GetTutorTableLengthError, (state, action): TutorState => {
    return {
      ...state,
      tableTutorError: action.error,
    };
  }),
  on(ResetTutorTable, (state): TutorState => {
    return {
      ...state,
    };
  }),
  on(GetTutorTableLengthError, (state, action): TutorState => {
    return {
      ...state,
      tableTutorError: action.error,
    };
  }),
  on(ResetTutorCrud, (state): TutorState => {
    return {
      ...state,
      crudResult: null,
      crudTutorLoader: false,
      crudTutorError: null,
    };
  }),
  on(GetTutorUserProfile, (state): TutorState => {
    return {
      ...state,
      tutorUserProfile: null,
      crudTutorLoader: true,
      crudTutorError: null,
    }
  }),
  on(GetTutorUserProfileSuccess, (state, action): TutorState => {
    return {
      ...state,
      tutorUserProfile: action.tutorProfile,
      crudTutorLoader: false,
      crudTutorError: null,
    }
  }),
  on(GetTutorUserProfileError, (state, action): TutorState => {
    return {
      ...state,
      crudTutorLoader: false,
      crudTutorError: action.error,
    }
  }),
  on(UpdateTutorGroupTable, (state): TutorState => {
    return {
      ...state,
      tutorTableLoader: true
    }
  }),
  on(GetGroupTutorCount, (state): TutorState => {
    return {
      ...state,
      groupTutorCount: null,
      groupTutotCountError: null,
      groupTutorCountLoader: true
    }
  }),
  on(GetGroupTutorCountSuccess, (state, action): TutorState => {
    return {
      ...state,
      groupTutorCountLoader: false,
      groupTutorCount: action.result
    }
  }),
  on(GetGroupTutorCountError, (state, action): TutorState => {
    return {
      ...state,
      groupTutorCountLoader: true,
      groupTutotCountError: action.error
    }
  }),
  on(TutorHasAccessToLearner, (state): TutorState => {
    return  {
      ...state,
      hasAccessToLearner: null,
      hasAccessToLearnerLoader: true,
      hasAccessToLearnerError: null,
    }
  }),
  on(TutorHasAccessToLearnerSuccess, (state, action): TutorState => {
    return  {
      ...state,
      hasAccessToLearner: action.result,
      hasAccessToLearnerLoader: false,
      hasAccessToLearnerError: null,
    }
  }),
  on(TutorHasAccessToLearnerError, (state, action): TutorState => {
    return  {
      ...state,
      hasAccessToLearnerLoader: false,
      hasAccessToLearnerError: action.error,
    }
  }),
  on(GetCurrentPageNumber, (state): TutorState => {
    return {
      ...state,
      tutorTableError: null,
      currentPageNumber: 0
    };
  }),
  on(GetCurrentPageNumberSuccess, (state, action): TutorState => {
    return {
      ...state,
      currentPageNumber: action.currentPageNumber
    }
  }),
  on(GetCurrentPageNumberError, (state, action): TutorState => {
    return {
      ...state,
      tutorTableError: action.error,
    }
  }),
  on(UpdateTutorAccountStatus, (state): TutorState => {
    return {
      ...state,
      tutorTableLoader: true,
      updateTutorAccountStatusLoader: true,
      isTutorAccountStatusUpdateSuccessful: false,
      updateTutorAccountStatusError: null
    }
  }),
  on(UpdateTutorAccountStatusSuccess, (state, action): TutorState => {
    return {
      ...state,
      tutorTableLoader: false,
      updateTutorAccountStatusLoader: false,
      isTutorAccountStatusUpdateSuccessful: action.isTutorAccountStatusUpdateSuccessful,
      updateTutorAccountStatusError: null
    }
  }),
  on(UpdateTutorAccountStatusError, (state, action): TutorState => {
    return {
      ...state,
      tutorTableLoader: false,
      updateTutorAccountStatusLoader: false,
      isTutorAccountStatusUpdateSuccessful: false,
      updateTutorAccountStatusError: action.error
    }
  }),
  on(ResetUpdateTutorAccountStatusProps, (state): TutorState => {
    return {
      ...state,
      tutorTableLoader: false,
      updateTutorAccountStatusLoader: false,
      isTutorAccountStatusUpdateSuccessful: false,
      updateTutorAccountStatusError: null
    }
  }),
  on(UpdateTutorTable, (state): TutorState => {
    return {
      ...state,
      tutorTableLoader: true,
      tableTutorError: false,
    };
  })
);
